var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar",class:{ 'progress-bar--indeterminate': _vm.indeterminate }},[_c('div',{staticClass:"progress-bar__fill",style:(_vm.indeterminate ? null : { width: `${_vm.percentage}%`, background: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }